import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllCountries = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetCountries}?CompanyCode=${companyCode}`
  );
  return data;
};

const getCountryById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CountryAPI}?isAll=false&code=${code}`
  );
  return data;
};

const insertCountry = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.CountryAPI, input);
  return data;
};

const updateCountry = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.CountryAPI, input);
  return data;
};

const deleteCountry = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.CountryAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetCountriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCountries],
    queryFn: () => getAllCountries(input),
  });
};

export const useGetCountryByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.CountryAPI],
    queryFn: () => getCountryById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertCountryMutation = () => {
  return useMutation({
    mutationFn: insertCountry,
  });
};

export const useUpdateCountryMutation = () => {
  return useMutation({
    mutationFn: updateCountry,
  });
};

export const useDeleteCountryMutation = () => {
  return useMutation({
    mutationFn: deleteCountry,
  });
};
